import dayjs from 'dayjs';
// Removed isBetween plugin import
import { DATE_FORMATS, DATE_FORMAT_HYPHEN } from './constants';

export const formatDate = (date, format = DATE_FORMAT_HYPHEN) => {
  return date ? dayjs(date).format(format) : date;
};

export const isDateBetween = (inputDate, minDate, maxDate) => {
  // Accepts dayjs objects or native Date/ISO strings
  const input = dayjs(inputDate);
  const min = dayjs(minDate);
  const max = dayjs(maxDate);
  return input.isAfter(min) && input.isBefore(max);
};

export const yupDateTimeTransformer = (_, originalValue) => {
  return originalValue ? dayjs(originalValue, 'DD/MM/YYYY HH:mm').toDate() : originalValue;
};

export const yupDateTransformer = (_, originalValue) => {
  return originalValue ? dayjs(originalValue, DATE_FORMATS).toDate() : originalValue;
};
